import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT_GIFT_CARDS } from './route-names'

const routes: RouteRecordRaw[] = [
  {
    path: 'checkout/gift-cards/:requestId',
    name: CHECKOUT_GIFT_CARDS.SELF,
    component: () =>
      import(
        '~/scopes/checkout/flows/gift-card/layout/GiftCardFlow/GiftCardFlow.vue'
      ),
    redirect: { name: CHECKOUT_GIFT_CARDS.BILLING_ADDRESS },
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
    children: [
      {
        path: 'billing-address',
        name: CHECKOUT_GIFT_CARDS.BILLING_ADDRESS,
        component: () =>
          import(
            '~/scopes/checkout/flows/gift-card/pages/BillingAddressStep/BillingAddressStep.vue'
          ),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
        },
      },
      {
        path: 'payment',
        name: CHECKOUT_GIFT_CARDS.PAYMENT,
        component: () =>
          import(
            '~/scopes/checkout/flows/gift-card/pages/PaymentStep/PaymentStep.vue'
          ),
        meta: {
          owners: ['bot-squad-b2cservices-front'],
          auth: {
            required: true,
            redirection: {
              name: ROUTES.AUTH.LOGIN,
              query: { bm_journey: 'checkout' },
            },
          },
          payment: {
            contentSecurityPoliciesEnabled: true,
          },
        },
      },
      {
        path: 'webview',
        redirect: { name: CHECKOUT_GIFT_CARDS.WEBVIEW.BILLING_ADDRESS },
        children: [
          {
            path: 'billing-address',
            name: CHECKOUT_GIFT_CARDS.WEBVIEW.BILLING_ADDRESS,
            component: () =>
              import(
                '~/scopes/checkout/flows/gift-card/pages/BillingAddressStep/BillingAddressStep.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
              auth: {
                required: true,
                redirection: {
                  name: ROUTES.AUTH.LOGIN,
                  query: { bm_journey: 'checkout' },
                },
              },
            },
          },
          {
            path: 'payment',
            name: CHECKOUT_GIFT_CARDS.WEBVIEW.PAYMENT,
            component: () =>
              import(
                '~/scopes/checkout/flows/gift-card/pages/PaymentStep/PaymentStep.vue'
              ),
            meta: {
              owners: ['bot-squad-b2cservices-front'],
              auth: {
                required: true,
                redirection: {
                  name: ROUTES.AUTH.LOGIN,
                  query: { bm_journey: 'checkout' },
                },
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: 'checkout/gift-card/:requestId/payment-result',
    name: CHECKOUT_GIFT_CARDS.PAYMENT_RESULT,
    component: () =>
      import('~/scopes/checkout/pages/GiftCardsResults/GiftCardsResults.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
        redirection: {
          name: ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'checkout' },
        },
      },
    },
  },
]

export default routes
